#import "../fragments/market-for-lead-fragment.graphql"
#import "../fragments/products-mutation-fragment.graphql"

mutation UpdateMarketForLead($input: LeadMarketUpdateInput!) {
    leadMarketUpdate(input: $input) {
        lead {
            id
            ...MarketForLeadFragment
            ...ProductMutationFragment
        }
    }
}
